var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50144 17.3447L8.50144 9.678L15.5014 17.3447L16.1201 16.6671L9.12006 9.00046L16.1201 1.33379L15.5014 0.65625L8.50144 8.32292L1.50144 0.65625L0.882812 1.33379L7.88281 9.00046L0.882812 16.6671L1.50144 17.3447Z",
    fill: "#1D1D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcons);
export default __webpack_public_path__ + "static/media/crossIcons.b8418de3c862022e7a7f944fe0716210.svg";
export { ForwardRef as ReactComponent };